import { useHistory } from 'react-router-dom';
import LangEnum from '../../../../../lang/LangEnum';
import snackbarStore from '../../../../../stores/Snackbar.store';
import { useTranslation } from '../../../../translation/TranslationContext';
import { useApplicationContext } from '../../ApplicationContext';
import { Brand } from '../../applicationContext.types';
import useAppEnvironment from '../useAppEnvironment/useAppEnvironment';

const useEnterBrand = () => {
  const { team, changeBrand } = useApplicationContext();
  const { applyEnvironment } = useAppEnvironment();
  const { translate } = useTranslation();
  const history = useHistory();
  const { handleMessage } = snackbarStore;

  const enterBrand = (brand: Brand) => {
    applyEnvironment(team?.role, brand.id);
    changeBrand(brand);
    history.push(`/${brand.slug}`);
    handleMessage({ type: 'info', message: translate(LangEnum.BRAND_CHANGED_MESSAGE) });
  };

  return { enterBrand };
};

export default useEnterBrand;
